import React, { useEffect, useState } from 'react';
import { Container, Spinner, Table, Accordion, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';



export default function ItemModelMpmShort({ item, quantity = null, showDetails = true }) {


    useEffect(() => {
        init()
    }, []);

    async function init() {

        let constraints = [
            { fieldName: "item_id", type: "value", value: item.id },
            { fieldName: "isDefault", type: "value", value: 1 }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('gyv_mpm', 1, 1, sorting, '', {}, constraints)
        console.warn('mpm', response)
        if (response.success === 1 && response.body.length > 0) {
            var id = response.body[0].id
            const body = {
                mpmId: id
            }
            console.log(body);

            const response2 = await ApiManager.sendAuthenticatedRequest('/custom/get_mpm_print_data', body);
            if (response2.success === 1) {
                var t = response2.body
                console.warn(response2.body)
                setData(t)
            }
            else {
                console.warn(response)
                setData([])
            }
        }
        else {
            setData([])
        }
    }

    const [data, setData] = useState(null);
    const [flatData, setFlatData] = useState(null);

    useEffect(() => {
        if (data) {
            const buildTree = (data) => {
                const nodesById = {};
                const tree = [];

                // Create a mapping for each node and add a children array
                data.forEach(row => {
                    nodesById[row.item_id] = { ...row, children: [] };
                });

                // Assign each node to its parent's children array if possible
                data.forEach(row => {
                    const node = nodesById[row.item_id];
                    // Check if the parent exists in our mapping
                    if (row.id_parent_item && nodesById[row.id_parent_item]) {
                        nodesById[row.id_parent_item].children.push(node);
                    } else {
                        tree.push(node);
                    }
                });

                return tree;
            };

            // Flatten the tree recursively to generate an array with computed level depth
            const flattenTree = (nodes, level = 0, maxLevel = 0) => {
                let flat = [];
                nodes.forEach(node => {
                    flat.push({ ...node, level });
                    if (level < maxLevel && node.children?.length) {
                        flat = flat.concat(flattenTree(node.children, level + 1, maxLevel));
                    }
                });
                return flat;
            };

            // Build and flatten the tree structure
            const treeData = buildTree(data);
            const flatDataTemp = flattenTree(treeData, 0, 1);

            setFlatData(flatDataTemp)

        }
    }, [data]);



    if (data !== null && flatData !== null) {
        return (
            <>
                {flatData.map((item, i) => {

                    return (
                        <Accordion className='mb-2' key={i} style={{ marginLeft: `${item.level * 40}px` }}>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <span className='small'>
                                        <FontAwesomeIcon icon={'cube'} className='me-2' />
                                        {item.quantity ? item.quantity : '1'} x {item.name} ({item.code})
                                    </span>

                                    {quantity && (
                                        <span className='ms-2'>
                                            {item.quantity * 1 * quantity > item.availableQuantity ? (
                                                <FontAwesomeIcon icon="circle" color='red' />
                                            ) : (
                                                <FontAwesomeIcon icon="circle" color='green' />
                                            )}
                                        </span>
                                    )}
                                </Accordion.Header>
                                <Accordion.Body className='me-0 pe-0'>
                                    {showDetails === true && (
                                        <Row className='pe-3'>
                                            <Col xs={12} md={12} className='mt-3'>
                                                <Table striped className='small'>
                                                    <tbody>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="warehouse" /></td>
                                                            <td>Giacenza interna</td>
                                                            <td>{item.stockQuantityInternal}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="warehouse" /></td>
                                                            <td>Giacenza fornitori</td>
                                                            <td>{item.stockQuantitySuppliers}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="cart-shopping" /></td>
                                                            <td>Quantità ordinata</td>
                                                            <td>{item.orderedQuantity}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="circle-question" /></td>
                                                            <td>Centrale - impegnato =</td>
                                                            <td>{item.stockQuantityInternal - item.customerPendingQuantity}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="warehouse" /></td>
                                                            <td>Disponibilità immediata</td>
                                                            <td>{item.availableQuantity}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-center'><FontAwesomeIcon icon="warehouse" /></td>
                                                            <td>Disponibilità futura</td>
                                                            <td>{item.futureAvailability}</td>
                                                        </tr>
                                                        
                                                        
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    )
                })}
            </>
        )
    }
    else {
        return (
            <Spinner />
        )
    }
};